import React from "react";
import PropTypes from "prop-types";

const externalLinkProps = {
  target: "_blank",
  rel: "noreferrer noopener",
};

const Link = ({ children, href, isExternal, ...rest }) => (
  <a {...rest} {...(isExternal ? externalLinkProps : {})} href={href}>
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
};

Link.defaultProps = {
  isExternal: false,
};

export default Link;
